<template>
  <div class="login-container">
    <div class="login-form">
      <div class="content flex items-center justify-between">
        <!-- 左侧 -->
        <div class="form-l">
          <div class="title">
            <div>云南省高校</div>
            <div>人才市场</div>
          </div>
          <div class="form-l-shading">
            <img style="width: 100%" src="@/assets/images/login/bg-pattern.png" alt="" />
          </div>
          <!-- 登录|注册按钮切换 -->
          <login-method-switch :current="current" @click="handleLoginMethodSwitch" />
        </div>
        <!-- 右侧 -->
        <div class="form-r">
          <login-form :type="formType" @update:type="formType = $event" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginMethodSwitch from "./cpns/switch";
import LoginForm from "./cpns/login-form/index.vue";

export default {
  components: {
    LoginMethodSwitch,
    LoginForm,
  },
  data() {
    return {
      formType: "login",
    };
  },
  computed: {
    current() {
      return this.formType === "login" ? 0 : 1;
    },
  },
  methods: {
    handleLoginMethodSwitch({ item }) {
      this.formType = item.value;
    },
  },
};
</script>

<style scoped lang="scss">
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  height: 100vh;
  background-image: url("@/assets/images/login/bg.png");
  background-position: center;
  background-size: 100% 100%;
  width: 100%;
}

.login-form {
  box-sizing: border-box;
  width: 73.4%;
  max-width: 1400px;
  height: 80.5%;
  background: #FFFFFF;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    width: 100%;
    height: 100%;
  }
}

.form-l {
  position: relative;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  // align-items: center;
  background: linear-gradient(0deg, #EBA091 0%, #CC3B16 100%);
  border-radius: 10px;
  width: 36.3%;
  height: 100%;
  // padding: 12% 0;
  position: relative;

  .title {
    position: absolute;
    font-size: 42px;
    line-height: 70px;
    display: flex;
    flex-direction: column;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    top: 20%;
  }

  .form-l-shading {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

.form-r {
  box-sizing: border-box;
  flex: 1;
  padding-left: 10%;
  padding-right: 10%;
  padding-top: clamp(12px, 2vw, 24px);
  padding-bottom: clamp(12px, 2vw, 24px);
  // padding: 12% 10%;
  
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {
  .login-form {
    width: 90%;
    height: 85%;
  }

  .form-l {
    width: 40%;

    .title {
      font-size: 32px;
      line-height: 52px;
      top: 22%;
    }
  }

  .form-r {
    padding-left: 6%;
    padding-right: 6%;
  }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .login-container {
    height: auto;
    min-height: 100vh;
    padding: 20px 0;
    background-size: cover;
    align-items: flex-start;
  }

  .login-form {
    width: 92%;
    height: auto;
    max-height: none;
    margin: 0 auto;
  }

  .content {
    flex-direction: column;
  }

  .form-l {
    width: 100%;
    height: 240px;
    min-height: 200px;
    border-radius: 10px 10px 0 0;
    flex-shrink: 0;

    .title {
      font-size: 28px;
      line-height: 44px;
      top: 28%;
    }

    .form-l-shading {
     display: none;
    }
  }

  .form-r {
    padding: 30px 5% 36px;
  }
}

/* 小屏手机适配 */
@media screen and (max-width: 480px) {
  .login-container {
    padding: 12px 0;
  }

  .login-form {
    width: 96%;
  }

  .form-l {
    height: 18、90px;
    min-height: 160px;

    .title {
      font-size: 24px;
      line-height: 36px;
      top: 26%;
    }

    .form-l-shading {
     display: none;
    }
  }

  .form-r {
    padding: 24px 4% 28px;
  }
}
</style>
